<!--中间左边-->
<template>
	<div class="middleLeftBody">
		<!--治污设施情况-->
		<div class="zwseqk" :style="getBackgroudImageStyle('/huanbao/billboard/zwqk.png')">
			<div class="zwseqwLeft">
				<span class="zwseqwLeftSpan">
            		<span>昨</span><br/>
				<span>日</span>
				</span>
				<span class="zwseqwLeftSpan">
            		<span>今</span><br/>
				<span>日</span>
				</span>
			</div>
			<table>
				<tr>
					<td colspan="2" class="colorBlue">治污设施情况</td>
					<td colspan="2" class="colorBlue">限产/停产执行情况</td>
				</tr>
				<tr>
					<td>异常企业</td>
					<td class="colorBlue">31家</td>
					<td>执行企业</td>
					<td class="colorBlue">2家</td>
				</tr>
				<tr>
					<td>涉及产污设施</td>
					<td class="colorBlue">48处</td>
					<td>未执行企业</td>
					<td class="colorBlue">0处</td>
				</tr>
				<tr>
					<td>异常企业</td>
					<td class="colorBlue">26家</td>
					<td>执行企业</td>
					<td class="colorBlue">2家</td>
				</tr>
				<tr>
					<td>涉及产污设施</td>
					<td class="colorBlue">32处</td>
					<td>未执行企业</td>
					<td class="colorBlue">0处</td>
				</tr>
			</table>
		</div>
		<!--错峰生产对比-->
		<div class="cfsc" :style="getBackgroudImageStyle('/huanbao/billboard/zwqk.png')">
			<div class="cfscTitle" :style="getBackgroudImageStyle('/huanbao/billboard/title.png')">
				<span class="colorBlue">AQI/错峰生产对比</span>
			</div>
			<div class="cfscContent">
				<vchart style="height:100%;width: 100%;" ref='vchartCfsc' />
			</div>
		</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart,
		},
		props: {},
		data() {
			return {
				options: {},
			}
		},
		created() {},
		mounted() {
			this.cfscChart()
		},
		destroyed() {},
		computed: {
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			}
		},
		watch: {},
		methods: {
			cfscChart() {
				//错峰生产
				let options = this.$refs.vchartCfsc.getDefaultOptions()
				options.title = {
					text: '红色预警限产20%',
					subtext: '',
					x: 'center',
					align: 'right',
					textStyle:{
						color:'#01429a',
					}
				}
				options.toolbox = {
					show: false
				}
				options.xAxis = {
					type: 'category',
					axisLabel: {
						formatter: '{value}',
						textStyle: {
							color: '#ffffff',
						}
					},
					data: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
				}
				options.yAxis={
					axisLabel: {
						formatter: '{value}',
						textStyle: {
							color: '#ffffff',
						}
					},
				}
				options.tooltip = {
					trigger: 'axis',
					confine: true,
					formatter: (params, ticket, callback) => {
						var label = ''
						params.forEach(item => {
							var values;
							if(isnull(item.value)) {
								values = "无采集数据";
							} else {
								values = item.value;
							}
							label += item.axisValue + " : " + values + "</br>"
						})
						return label;
					},
					axisPointer: {
						animation: false
					}
				}
				options.series = [{
					type: 'line',
					name: '生产用电',
					itemStyle:{
						color:'#2499ff'
					},
					data: [100, 200, 300, 200, 500, 200, 400, 100, 300, 200, 400, 300]
				}]
				options.grid = {
						height: '80%',
						width: '',
						left: '1%',
						right: '3%',
						bottom: '1%',
						containLabel: true
					},
				this.$refs.vchartCfsc.setData(options, true)
			}
		}
	}
</script>

<style scoped>
	.middleLeftBody {
		width: 25%;
		height: 100%;
		margin-left: 1%;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: space-between;
	}
	
	.zwseqk {
		width: 100%;
		height: 49%;
		display: flex;
		align-items: center;
	}
	
	.cfsc {
		width: 100%;
		height: 49%;
		margin-bottom: 1%;
	}
	
	.zwseqwLeft {
		width: 10%;
		height: 100%;
		display: flex;
		align-items: end;
		flex-direction: column;
		justify-content: space-around;
	}
	
	.zwseqwLeft .zwseqwLeftSpan {
		background-color: #003462;
		padding: .08rem;
	}
	
	.zwseqwLeft .zwseqwLeftSpan:nth-child(1) {
		margin-top: .5rem;
	}
	
	.zwseqwLeft .zwseqwLeftSpan span {
		color: white;
	}
	
	.zwseqk table {
		width: 75%;
		height: 100%;
		margin-left: 5%;
	}
	
	.zwseqk table tr td {
		color: white;
	}
	
	.zwseqk table tr:nth-child(1) td {
		text-align: center;
		font-size: .18rem;
		padding-left: 0 !important;
	}
	
	.zwseqk table tr td:nth-child(1) {
		padding-left: .2rem;
	}
	
	.zwseqk table tr td:nth-child(3) {
		padding-left: .2rem;
	}
	
	.colorBlue {
		color: #309efe !important;
	}
	
	.cfscTitle {
		width: 35%;
		height: 12%;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.cfscTitle span {
		color: white;
		font-size: .16rem;
	}
	
	.cfscContent {
		width: 100%;
		height: 88%;
	}
</style>